export default "__VITE_ASSET__HvvsOilX__"